import React from 'react';
import { ViewMode } from '../types/room';
import { Grid3x3 } from 'lucide-react';
interface ViewControlsProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}
export function ViewControls({
  viewMode,
  onViewModeChange
}: ViewControlsProps) {
  return <div className="bg-[#2D2D2D] border border-[#4A4A4A] rounded-lg p-1 flex gap-1" data-id="element-595">
      <button onClick={() => onViewModeChange('top')} className={`
          px-4 py-2 rounded flex items-center gap-2 text-sm font-medium transition-colors
          ${viewMode === 'top' ? 'bg-[#4FC3F7] text-white' : 'text-[#B0B0B0] hover:bg-[#3A3A3A] hover:text-white'}
        `} data-id="element-596">
        <Grid3x3 size={16} data-id="element-597" />
        TOP
      </button>

      <button onClick={() => onViewModeChange('3d')} className={`
          px-4 py-2 rounded flex items-center gap-2 text-sm font-medium transition-colors
          ${viewMode === '3d' ? 'bg-[#4FC3F7] text-white' : 'text-[#B0B0B0] hover:bg-[#3A3A3A] hover:text-white'}
        `} data-id="element-598">
        <div size={16} data-id="element-599" />
        3D
      </button>
    </div>;
}